/* projetinconnu — theme JS (vanilla) */
(function () {
  "use strict";
  var PI = window.PI || {};

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var fmt = PI.money_format || "${{amount}}";
    return fmt.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  /* ---------- cart drawer ---------- */
  var drawer = $("[data-cart-drawer]");
  function openDrawer() { if (drawer) { drawer.setAttribute("data-open", ""); document.body.style.overflow = "hidden"; } }
  function closeDrawer() { if (drawer) { drawer.removeAttribute("data-open"); document.body.style.overflow = ""; } }

  document.addEventListener("click", function (e) {
    var openT = e.target.closest("[data-cart-open]");
    var closeT = e.target.closest("[data-cart-close]");
    if (openT && drawer) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (closeT) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  function renderCart(cart) {
    $all("[data-cart-count]").forEach(function (el) { el.textContent = "(" + cart.item_count + ")"; });
    var body = $("[data-cart-body]");
    var foot = $("[data-cart-foot]");
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p class="mono">Empty for now</p><p>Nothing in your cart.</p></div>';
      if (foot) foot.hidden = true;
      return;
    }
    var html = "";
    cart.items.forEach(function (it) {
      html += '<div class="line" data-line-key="' + it.key + '">' +
        (it.image ? '<img class="line__img" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, "_120x150$1$2") + '" alt="">' : '<span class="line__img"></span>') +
        '<div><div class="line__name">' + it.product_title + "</div>" +
        '<div class="line__meta">' + (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title + " · " : "") + "Qty " + it.quantity + "</div>" +
        '<button type="button" class="line__remove" data-line-remove="' + it.key + '">Remove</button></div>' +
        '<div class="line__price">' + money(it.final_line_price) + "</div></div>";
    });
    body.innerHTML = html;
    if (foot) {
      foot.hidden = false;
      var sub = $("[data-cart-subtotal]");
      if (sub) sub.textContent = money(cart.total_price);
    }
  }

  function refreshCart() {
    return fetch(PI.routes.cart, { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  /* add to cart (AJAX) */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-product-form]");
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector("[data-add-btn]");
    if (btn) { btn.setAttribute("disabled", ""); btn.dataset.label = btn.textContent; btn.textContent = "…"; }
    fetch(PI.routes.cart_add, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(serialize(form)) })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); })
      .catch(function () { window.location.href = "/cart"; })
      .finally(function () { if (btn) { btn.removeAttribute("disabled"); btn.textContent = btn.dataset.label || "Add to cart"; } });
  });

  function serialize(form) {
    var id = form.querySelector("[name='id']");
    var qty = form.querySelector("[name='quantity']");
    return { id: id ? id.value : null, quantity: qty ? parseInt(qty.value, 10) || 1 : 1 };
  }

  /* remove line */
  document.addEventListener("click", function (e) {
    var rm = e.target.closest("[data-line-remove]");
    if (!rm) return;
    e.preventDefault();
    fetch(PI.routes.cart_change, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: rm.getAttribute("data-line-remove"), quantity: 0 }) })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  });

  /* ---------- qty stepper ---------- */
  document.addEventListener("click", function (e) {
    var step = e.target.closest("[data-qty-step]");
    if (!step) return;
    var wrap = step.closest(".qty");
    var input = wrap && wrap.querySelector("input");
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += step.getAttribute("data-qty-step") === "up" ? 1 : -1;
    input.value = Math.max(1, v);
  });

  /* ---------- mobile menu ---------- */
  var mm = $("[data-mobile-menu]");
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-menu-open]")) { if (mm) { mm.setAttribute("data-open", ""); document.body.style.overflow = "hidden"; } }
    if (e.target.closest("[data-menu-close]")) { if (mm) { mm.removeAttribute("data-open"); document.body.style.overflow = ""; } }
  });

  /* ---------- PDP gallery ---------- */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest("[data-gallery-thumb]");
    if (!thumb) return;
    var main = $("[data-gallery-main]");
    var src = thumb.getAttribute("data-full");
    if (main && src) { main.src = src; }
    $all("[data-gallery-thumb]").forEach(function (t) { t.setAttribute("aria-current", t === thumb ? "true" : "false"); });
  });

  /* ---------- countdown ---------- */
  $all("[data-countdown]").forEach(function (el) {
    var target = new Date(el.getAttribute("data-countdown")).getTime();
    if (isNaN(target)) { el.setAttribute("hidden", ""); return; }
    var parts = {
      d: el.querySelector("[data-cd-d]"), h: el.querySelector("[data-cd-h]"),
      m: el.querySelector("[data-cd-m]"), s: el.querySelector("[data-cd-s]")
    };
    function pad(n) { return (n < 10 ? "0" : "") + n; }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { el.setAttribute("data-live", ""); diff = 0; }
      var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5),
          m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
      if (parts.d) parts.d.textContent = pad(d);
      if (parts.h) parts.h.textContent = pad(h);
      if (parts.m) parts.m.textContent = pad(m);
      if (parts.s) parts.s.textContent = pad(s);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- reveal on scroll (re-triggers up & down) ---------- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle("is-in", en.isIntersecting); });
    }, { threshold: 0.14, rootMargin: "0px 0px -6% 0px" });
    $all("[data-reveal]").forEach(function (el) { io.observe(el); });
  }

  /* ---------- coming soon gate ---------- */
  var gate = document.querySelector("[data-gate]");
  if (gate) {
    var gateAuthed = false;
    try { gateAuthed = localStorage.getItem("pi_gate_ok") === "1"; } catch (e) {}
    if (gateAuthed) {
      if (gate.parentNode) gate.parentNode.removeChild(gate);
    } else {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      var gateUntil = new Date(gate.getAttribute("data-gate-until")).getTime();
      if (!isNaN(gateUntil)) {
        var gateTimer = setInterval(function () {
          if (Date.now() >= gateUntil) { clearInterval(gateTimer); window.location.reload(); }
        }, 1000);
      }
      var gLogin = gate.querySelector("[data-gate-login]");
      var gPass = gate.querySelector("[data-gate-pass]");
      var gInput = gate.querySelector("[data-gate-pass-input]");
      var gBtn = gate.querySelector("[data-gate-pass-btn]");
      if (gLogin && gPass) {
        gLogin.addEventListener("click", function () {
          gPass.hidden = false;
          gLogin.hidden = true;
          if (gInput) gInput.focus();
        });
      }
      var gateTry = function () {
        if (!gInput) return;
        if (gInput.value.trim().toLowerCase() === "scalera") {
          try { localStorage.setItem("pi_gate_ok", "1"); } catch (e2) {}
          document.documentElement.style.overflow = "";
          document.body.style.overflow = "";
          if (gate.parentNode) gate.parentNode.removeChild(gate);
        } else {
          gInput.value = "";
          gInput.placeholder = "wrong password";
        }
      };
      if (gInput) {
        gInput.addEventListener("keydown", function (e) {
          if (e.key === "Enter") { e.preventDefault(); gateTry(); }
        });
      }
      if (gBtn) gBtn.addEventListener("click", gateTry);
    }
  }

  /* ---------- intro splash ---------- */
  var intro = document.querySelector("[data-intro]");
  if (intro) {
    var introSeen = false;
    try { introSeen = !!sessionStorage.getItem("pi_intro_seen"); } catch (e) {}
    var killIntro = function () {
      intro.classList.add("is-done");
      document.body.style.overflow = "";
      try { sessionStorage.setItem("pi_intro_seen", "1"); } catch (e) {}
      setTimeout(function () { if (intro.parentNode) intro.parentNode.removeChild(intro); }, 700);
    };
    if (introSeen) {
      if (intro.parentNode) intro.parentNode.removeChild(intro);
    } else {
      document.body.style.overflow = "hidden";
      intro.addEventListener("click", killIntro);
      setTimeout(killIntro, 1500);
    }
  }

  /* ---------- info panel (? button) ---------- */
  var infoPanel = document.querySelector("[data-info-panel]");
  function closeInfo() { if (infoPanel) { infoPanel.removeAttribute("data-open"); document.body.style.overflow = ""; } }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-info-open]")) { if (infoPanel) { infoPanel.setAttribute("data-open", ""); document.body.style.overflow = "hidden"; } }
    if (e.target.closest("[data-info-close]")) { closeInfo(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeInfo(); });

  /* ---------- easter egg (? in footer) ---------- */
  document.addEventListener("click", function (e) {
    var ee = e.target.closest("[data-ee]");
    if (ee) { var w = ee.closest(".ee-wrap"); if (w) w.classList.toggle("is-open"); }
  });

  /* ---------- product reveal (smooth cinematic slide) ---------- */
  var stage = document.querySelector("[data-reveal-stage]");
  if (stage) {
    var rImgs = Array.prototype.slice.call(stage.querySelectorAll("[data-reveal-img]"));
    var hint = stage.querySelector("[data-reveal-hint]");
    var bar = stage.querySelector("[data-reveal-bar]");
    var rn = rImgs.length;
    var rTicking = false;
    function revealFrame() {
      var rect = stage.getBoundingClientRect();
      var total = stage.offsetHeight - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), total);
      var p = total > 0 ? scrolled / total : 0;
      var f = p * (rn - 1);
      for (var i = 0; i < rn; i++) {
        var off = i - f;
        var dist = Math.abs(off);
        var im = rImgs[i];
        im.style.opacity = Math.max(0, 1 - dist);
        im.style.transform = "translate3d(0," + (off * 110).toFixed(1) + "px,0)";
        im.style.zIndex = dist < 0.5 ? 2 : 1;
      }
      if (bar) bar.style.height = (p * 100).toFixed(1) + "%";
      if (hint) hint.classList.toggle("is-hidden", p > 0.03);
      rTicking = false;
    }
    function onReveal() { if (rTicking) return; rTicking = true; requestAnimationFrame(revealFrame); }
    window.addEventListener("scroll", onReveal, { passive: true });
    window.addEventListener("resize", onReveal);
    revealFrame();
  }

  /* ---------- carousel (product photos) ---------- */
  Array.prototype.slice.call(document.querySelectorAll("[data-car]")).forEach(function (car) {
    var track = car.querySelector("[data-car-track]");
    var slides = car.querySelectorAll(".car__slide");
    var dots = Array.prototype.slice.call(car.querySelectorAll("[data-car-dot]"));
    var prev = car.querySelector("[data-car-prev]");
    var next = car.querySelector("[data-car-next]");
    var count = slides.length, idx = 0, x0 = null;
    function go(k) {
      idx = Math.max(0, Math.min(count - 1, k));
      track.style.transform = "translateX(" + (-idx * 100) + "%)";
      dots.forEach(function (d, j) { d.classList.toggle("is-active", j === idx); });
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === count - 1;
    }
    if (prev) prev.addEventListener("click", function () { go(idx - 1); });
    if (next) next.addEventListener("click", function () { go(idx + 1); });
    dots.forEach(function (d) { d.addEventListener("click", function () { go(parseInt(d.getAttribute("data-car-dot"), 10)); }); });
    car.addEventListener("pointerdown", function (e) { x0 = e.clientX; });
    car.addEventListener("pointerup", function (e) { if (x0 === null) return; var dx = e.clientX - x0; if (dx < -40) go(idx + 1); else if (dx > 40) go(idx - 1); x0 = null; });
    car.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    car.addEventListener("touchend", function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (dx < -40) go(idx + 1); else if (dx > 40) go(idx - 1); x0 = null; });
    go(0);
  });

  /* ---------- newsletter (saves to Shopify; inline success, no reload) ---------- */
  document.addEventListener("submit", function (e) {
    var nf = e.target.closest("[data-newsletter]");
    if (!nf) return;
    if (nf.checkValidity && !nf.checkValidity()) return;
    e.preventDefault();
    try {
      fetch(nf.action, { method: "POST", body: new FormData(nf), headers: { "Accept": "application/json" } }).catch(function () {});
    } catch (err) {}
    nf.classList.add("is-sent");
  });
})();
